module.exports = __webpack_public_path__ + "img/6.461eb0f8.png";